import React from 'react';
import { PromptGroup } from 'types/candidateStories';
import PromptSummaryItem from './PromptSummaryItem';

const PromptSummaryItemsList = ({
  promptResponses,
  recordId = '',
  promptGroups,
}: {
  promptResponses: Record<string, string>;
  recordId?: string;
  promptGroups: PromptGroup[];
}) => {
  return (
    <div data-testid='prompt-summary-items-list'>
      {Object.entries(promptResponses).map(([promptItemId, response]) => (
        <PromptSummaryItem
          key={recordId ? `${recordId}-${promptItemId}` : promptItemId}
          promptItemId={promptItemId}
          response={response}
          promptGroups={promptGroups}
          recordId={recordId}
        />
      ))}
    </div>
  );
};

export default PromptSummaryItemsList;
